"use client";

import { FC, useState } from "react";
import Image from "next/image";
import clsx from "clsx";
import { Drawer } from "@mantine/core";

import TButton from "@/components/atoms/buttons/TButton";
import CTAButton from "@/components/atoms/buttons/CTAButton";
import HeaderSubMenuDrawer from "./HeaderSubMenuDrawer";
import icon from "@/utils/icon.helper";

import { IHeaderMenuItem } from "./DesktopHeader";

// --------------------------------------------------------------------------------------------------

export type ISetDrawer = {
  open: () => void;
  close: () => void;
  toggle: () => void;
};

export type IHeaderMainMenuProps = {
  mainMenuOpened: boolean;
  subMenuOpened: boolean;
  setSubMenu: ISetDrawer;
  setMainMenu: ISetDrawer;
  mainMenu?: (IHeaderMenuItem | undefined)[];
  className?: string;
};

const HeaderMainMenu: FC<IHeaderMainMenuProps> = (props) => {
  const {
    mainMenu,
    mainMenuOpened,
    subMenuOpened,
    setMainMenu,
    setSubMenu,
    className,
  } = props;

  const [subMenuIndex, setSubMenuIndex] = useState<number>(0);

  return (
    <Drawer
      className={clsx("xl:hidden", className)}
      size="100%"
      opened={mainMenuOpened}
      onClose={setMainMenu.close}
      zIndex={998}
      keepMounted
      transitionProps={{ duration: 150, transition: "slide-right" }}
    >
      <div className="container h-full w-full flex-col lg:w-auto">
        {mainMenu && mainMenu.length > 0 && (
          <div className="flex h-full flex-col flex-wrap space-y-6 py-8 font-bricolage-grotesque text-base">
            {mainMenu.map(
              (item, idx) =>
                item && (
                  <div
                    key={idx}
                    className="flex cursor-pointer items-center justify-start font-bricolage-grotesque text-base font-normal text-black-900"
                    onClick={() => {
                      setSubMenuIndex(idx);
                      setSubMenu.open();
                    }}
                  >
                    <span
                      // onClick={setMainMenu.close}
                      // href={item.href} // TODO: if link required - href for mobile header list link value
                      className="flex h-full w-full items-center px-3 focus:bg-gray-100"
                    >
                      {item.label}
                    </span>

                    {item.items && item.items.length > 0 && (
                      <Image
                        src={icon("chevron_right")}
                        alt="chevron_right"
                        height={12}
                        width={6}
                        style={{
                          height: "auto",
                          width: "auto",
                        }}
                        className="h-auto w-auto px-4 focus:bg-gray-100"
                      />
                    )}
                  </div>
                ),
            )}

            {/* Submenu Drawer */}
            <HeaderSubMenuDrawer
              subMenuOpened={subMenuOpened}
              setSubMenu={setSubMenu}
              setMainMenu={setMainMenu}
              heading={mainMenu[subMenuIndex]?.label}
              subMenuList={mainMenu[subMenuIndex]?.items}
              downloadBook={mainMenu[subMenuIndex]?.downloadBook}
              className="xl:hidden"
            />
          </div>
        )}

        <div onClick={setMainMenu.close}>
          <CTAButton
            id="get-consultancy-mobile-header-button"
            variant="orange"
            size="md"
            showIcon={true}
            iconType="arrow"
            iconPosition="right"
            href="/contact-us"
          >
            Book a Discovery Call
          </CTAButton>
        </div>
      </div>
    </Drawer>
  );
};

export default HeaderMainMenu;
